import "./Hero.css";
import { motion } from "framer-motion";

import heroVideo from "../../assets/xable.mp4";
import heroImage from "../../assets/image.png";

export default function Hero() {
  return (
    <section id="hero" className="hero">

      {/* VIDEO BACKGROUND (FULL WIDTH FIXED) */}
      <video
        className="hero-video"
        autoPlay
        muted
        loop
        playsInline
      >
        <source src={heroVideo} type="video/mp4" />
      </video>

      {/* RIGHT IMAGE LAYER (ABOVE VIDEO, BELOW CONTENT) */}
      <div
        className="hero-right-image"
        style={{ backgroundImage: `url(${heroImage})` }}
      />

      {/* DARK OVERLAY */}
      <div className="hero-overlay"></div>

      {/* CONTENT */}
      <div className="container">
        <div className="hero-content">

          {/* <motion.span
            className="hero-badge"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            AI & IoT SOLUTIONS
          </motion.span> */}

          <motion.h1
            className="hero-title"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            Integrated
            <br />
            <span>AI & IoT solutions</span>
            <br />
            <span style={{color:'#08469a'}}>Under One Roof.</span>
          </motion.h1>

          <motion.p
            className="hero-text"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 1 }}
          >
            We are Glintgan Technologies <br/>Revolutionize your systems with intelligent edge solutions.
            Converge AI and IoT pipelines for predictive insights and automation.
          </motion.p>

          <motion.div
            className="hero-buttons"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 1 }}
          >
            <button className="btn-primary-red">GET STARTED</button>
            <button className="btn-service">OUR SERVICES</button>
          </motion.div>

        </div>
      </div>

    </section>
  );
}